<!-- 小程序 -->
<template>
  <div class="messageAppearDetail" id="share-container" ref="screenshotContainer" :data-random="randomKey">
    <div class="mainInfo" id="mainInfo">
      <div class="wayInfo">
        <div class="message_map">
          <h4 class="header">
            <span>
              1.确认事件所在位置
              <i></i>
            </span>
          </h4>
          <div @click="PicLoction" id="mapLocation">
            <div class="mapBanner" v-show="!userCheckDetail && !isShowPicAndLoc">
              <img v-show="!messageObj.userSelectPoint" :src="mapImg" alt />
              <div :style="{ position: (!messageObj.userSelectPoint ? 'absolute' : 'relative'),visibility: (!messageObj.userSelectPoint ?  'hidden' : 'visible') }" id="container"></div>
            </div>
            <div class="mapBanner" v-show="userCheckDetail && !isShowPicAndLoc">
              <div :style="{ position: (!messageObj.userSelectPoint ? 'absolute' : 'relative'),visibility: (!messageObj.userSelectPoint ?  'hidden' : 'visible') }" id="container2"></div>
            </div>
            <img v-show="isShowPicAndLoc" :src="domToImageSrc" alt="">
            <p>地图位置{{ messageObj.locationWayName !== '' ? `:${messageObj.locationWayName}` : '' }}</p>
          </div>
        </div>
        <div class="wayName">
          <h4 class="header mg4">
            <span>
              2.事件地点道路名称
              <i></i>
            </span>
          </h4>
          <div v-if="!userCheckDetail && !userFillInComplete">
            <nut-input
              id="newAdd"
              v-model="messageObj.wayName"
              :class="['wayInfo_input', 'goOnInfo']"
              placeholder="请输入"
              clearable
              @clear="clearWayName"
            />
          </div>
          <div v-else>
            <div class="wayInfo_input goOnInfo wayNameCheck">{{ messageObj.wayName }}</div>
          </div>
        </div>
        <div class="wayPassStatus">
          <h4 class="header">
            <span>
              3.上报类型
              <i></i>
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <div class="btn_box">
              <template v-for="item in reportTypeBtnList" :key="item.id">
                <button
                  v-if="item.id <= 3"
                  style="margin-top: 14px"
                  @click="reportTypeBtnClick(item.id)"
                  :class="[item.active ? 'activeBtn':'defaultBtn']"
                >{{ item.name }}</button>
              </template>
            </div>
            <div class="btn_box">
              <template v-for="item in reportTypeBtnList" :key="item.id">
                <button
                  v-if="item.id < 7 && item.id > 3"
                  style="margin-top: 14px"
                  @click="reportTypeBtnClick(item.id)"
                  :class="[item.active ? 'activeBtn':'defaultBtn']"
                >{{ item.name }}</button>
              </template>
            </div>
            <div class="btn_box">
              <template v-for="item in reportTypeBtnList" :key="item.id">
                <button
                  v-if="item.id <= 9 && item.id >= 7"
                  style="margin-top: 14px"
                  @click="reportTypeBtnClick(item.id)"
                  :class="[item.active ? 'activeBtn':'defaultBtn', item.id === 9 ? 'hideBtn' : '']"
                >{{ item.name }}</button>
              </template>
            </div>
          </div>
          <div
            v-else
            class="checkWayState"
          >{{ messageObj.reportTypeLabel }}</div>
        </div>
        <div class="wayPassStatus">
          <h4 class="header">
            <span>
              4.车道类型
              <i></i>
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <div class="btn_box">
              <template v-for="item in laneTypeList" :key="item.id">
                <button
                  v-if="item.id <= 3"
                  style="margin-top: 14px"
                  @click="laneTypeBtnClick(item.id)"
                  :class="item.active ? 'activeBtn':'defaultBtn'"
                >{{ item.name }}</button>
              </template>
            </div>
            <div class="btn_box">
              <template v-for="item in laneTypeList" :key="item.id">
                <button
                  v-if="item.id > 3"
                  style="margin-top: 14px"
                  @click="laneTypeBtnClick(item.id)"
                  :class="[item.active ? 'activeBtn':'defaultBtn', item.id === 6 ? 'hideBtn' : '']"
                >{{ item.name }}</button>
              </template>
            </div>
          </div>
          <div
            v-else
            class="checkWayState"
          >{{ messageObj.laneTypeLabel }}</div>
          <div v-if="!userCheckDetail && messageObj.laneType.includes(1)">
            <nut-cell class="laneSelect" @click="showSelectLanePopup" is-link :desc="messageObj.laneTypePickerVal[0]">
              <template #title>
                <span class="span">主路车道选择<i class="required">*</i></span>
              </template>
            </nut-cell>
          </div>
        </div>
        <div class="wayPassStatus">
          <h4 class="header">
            <span>
              5.车道方向
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <div class="btn_box">
              <template v-for="item in laneDirectionList" :key="item.id">
                <button
                  v-if="item.id <= 3"
                  style="margin-top: 14px"
                  @click="laneDirectionBtnClick(item.id)"
                  :class="item.active ? 'activeBtn':'defaultBtn'"
                >{{ item.name }}</button>
              </template>
            </div>
            <div class="btn_box">
              <template v-for="item in laneDirectionList" :key="item.id">
                <button
                  v-if="item.id > 3"
                  style="margin-top: 14px"
                  @click="laneDirectionBtnClick(item.id)"
                  :class="[item.active ? 'activeBtn':'defaultBtn', item.id === 6 ? 'hideBtn' : '']"
                >{{ item.name }}</button>
              </template>
            </div>
          </div>
          <div
            v-else
            class="checkWayState"
          >{{ messageObj.laneDirectionLabel }}</div>
          <div v-if="!userCheckDetail && messageObj.laneDirection === 5" class="message_description goOnInfo">
            <p class="otherReason">其他方向</p>
            <div>
              <nut-textarea
                v-model="messageObj.textareaValueLaneDirection"
                placeholder="请描述其他需要补充的内容"
              />
            </div>
          </div>
        </div>
        <!-- <div class="wayPassStatus">
          <h4 class="header">
            <span>
              6.是否管控
              <i></i>
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <div class="btn_box">
              <template v-for="item in isControlList" :key="item.id">
                <button
                  style="margin-top: 14px"
                  @click="isControlBtnClick(item.id)"
                  :class="[item.active ? 'activeBtn':'defaultBtn', item.id === 3 ? 'hideBtn' : '']"
                >{{ item.name }}</button>
              </template>
            </div>
          </div>
          <div
            v-else
            class="checkWayState"
          >{{ messageObj.isControlLabel }}</div>
        </div> -->
        <div class="wayPassStatus">
          <h4 class="header">
            <span>
              6.记录信息
              <i></i>
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <nut-cell class="laneSelect" is-link title="事件发生时间" :desc="messageObj.info.startTime" @click="showTimePicker('start')"></nut-cell>
            <nut-cell class="laneSelect" is-link title="事件结束时间" :desc="messageObj.info.endTime" @click="showTimePicker('end')"></nut-cell>
          </div>
          <div v-else>
            <nut-cell class="laneSelect" is-link title="事件发生时间" :desc="messageObj.info.startTime"></nut-cell>
            <nut-cell class="laneSelect" is-link title="事件结束时间" :desc="messageObj.info.endTime"></nut-cell>
          </div>
        </div>
        <div class="wayPassStatus message_uploader" :style="{ display: isShowPicAndLoc ? 'none' : 'block' }">
          <h4 class="header">
            <span>
              7. 现场情况
            </span>
          </h4>
          <div>
            <template v-for="(item, index) in messageObj.locationPics" :key="index">
              <div class="upladItem" v-if="item.src">
                <div>
                  <nut-cell>
                    <template v-slot:default>
                      <img crossorigin="anonymous" :src="item.src" @click="previewImageHandel(index)" />
                      <nut-icon
                        name="close-little"
                        class="iconDelete"
                        @click="uploadDelete(index)"
                        v-if="!userCheckDetail"
                      ></nut-icon>
                    </template>
                  </nut-cell>
                </div>
                <span class="span">现场图片{{index + 1}}</span>
              </div>
            </template>
            <div class="uploadCss" v-if="!userCheckDetail">
              <div @click="clack">
                <img src="../assets/image_message_appear/camera.png" alt />
                <input
                  type="file"
                  accept="image/*"
                  name="file"
                  id="file"
                  @change="locationPicsFileChange"
                  style="opacity:0"
                  mutiple
                />
              </div>
              <span>现场图片</span>
            </div>
          </div>
        </div>
        <div class="wayPassStatus message_uploader"
          :style="{ display: (messageObj.textareaValueRemake === '' && isShowPicAndLoc) ? 'none' : 'block' }">
          <h4 class="header">
            <span>
              {{ isShowPicAndLoc ? 7 : 8 }}. 备注补充
            </span>
          </h4>
          <div>
            <div class="message_description goOnInfo">
              <div v-if="!isShowPicAndLoc">
                <nut-textarea
                  max-length="100"
                  v-model="messageObj.textareaValueRemake"
                  placeholder="请描述其他需要补充的内容"
                  :disabled="userCheckDetail"
                />
              </div>
              <div v-else class="remakeDiv">{{ messageObj.textareaValueRemake }}</div>
            </div>
          </div>
        </div>
        <div class="appeared" :style="{ visibility: isShowPicAndLoc ? 'hidden' : 'visible' }">
          <button
            v-if="!userCheckDetail"
            @click="FillInEvent"
            :class="userFillInComplete ? 'complete ' : ''"
          >完成上报</button>
          <div v-else :class="['backEvent', !store.state.isH5 ? 'hiddenBackEvent' : '']">
            <button @click="backEvent" :class="userFillInComplete ? 'complete ' : ''">返回</button>
            <img class="shareF" @click="shareEvent" src="https://cdn.map.qq.com/miniprogram/images/shareF.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <t-popup v-model="laneTypeVisible" placement="bottom">
    <t-picker
      v-model="messageObj.laneTypePickerVal"
      :class="store.state.isH5 ? isIOS ? 't_date_time_picker_self newcss' : 't_date_time_picker_self newcss5' : 't_date_time_picker_self'"
      :columns="[columns]"
      @confirm="laneTypePickerConfirm"
      @cancel="laneTypeVisible = false"
    />
  </t-popup>
  <t-popup v-model="datePickerVisible" placement="bottom">
    <t-date-time-picker
      v-model="datePicker"
      :class="store.state.isH5 ? isIOS ? 't_date_time_picker_self newcss' : 't_date_time_picker_self newcss5' : 't_date_time_picker_self'"
      mode="minute"
      title="选择时间"
      :start="dateTimeStart"
      format="YYYY-MM-DD HH:mm"
      @confirm="datePickerConfirm"
      @cancel="datePickerVisible = false"
      style="font-size: 16px;"
    />
  </t-popup>
  <previewImage
    v-if="previewObj.showPreviewImg"
    :showPreviewImg="previewObj.showPreviewImg"
    :photoList="previewObj.imageList"
    :initPage="previewObj.initPage"
    :isViewExample="false"
    @setShowPreviewImg="getShowPreviewImg">
  </previewImage>
  <nut-popup :style="{ padding: '30px 50px', backgroundColor: 'transparent' }" @click-overlay="changeBasic" v-model:visible="showBasic">
    <nut-icon name="loading" size="30" color="#fff"></nut-icon>
  </nut-popup>
</template>
<script setup>
import { reactive, ref, onBeforeMount, onMounted, watch, nextTick, onUnmounted } from "vue";
import { mapImg } from './config';
import { setMiniImg } from '@/utils/utils';
import { useStore } from "vuex";
import request from "@/utils/request";
import { getCosCredentialsByScene, infoReport } from "@/utils/api";
import { Notify, Toast } from "@nutui/nutui";
import previewImage from "../components/previewImage";
import { useRoute, useRouter, onBeforeRouteLeave } from "vue-router";
import wx from 'weixin-js-sdk';
import { jsonp } from 'vue-jsonp'
import { citys } from "./city";
import html2canvas from "html2canvas";
import domtoimage from 'dom-to-image';

const screenshotContainer = ref(null); // 截图容器
const screenshotBase64 = ref(''); // 截图 base64 数据
const randomKey = ref(Math.random().toString(36).slice(2, 8)); // 截图容器随机数
const config = {
  // 水印配置
  watermark: {
    fontSize: '14px',
    color: 'rgba(0,0,0,0.05)',
    rotate: -15,
    spacing: 80,
    zIndex: 999,
  },
  // html2canvas 配置
  html2canvas: {
    scale: 2, // 2倍图，避免模糊
    allowTaint: true,
    useForeignObject: false,
    logging: false,
    useCORS: true, // 支持跨域图片
    scrollY: 0,
    scrollX: 0,
    x: 0,
    y: 0,
  },
};
const Cos = require("cos-js-sdk-v5");
const store = useStore();
const route = useRoute();
const router = useRouter();
const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
const { TMap } = window;

const messageObj = reactive({
  wayName: '',
  locationWayName: '',
  reportType: '',
  laneType: [],
  laneTypePickerVal: [],
  laneDirection: '',
  textareaValueLaneDirection: '',
  // isControl: '',
  reportTypeLabel: '', // 查看时展示使用
  laneTypeLabel: '', // 查看时展示使用
  laneDirectionLabel: '', // 查看时展示使用
  // isControlLabel: '', // 查看时展示使用
  info: {
    startTime: '请选择',
    endTime: '请选择',
  },
  locationPics: [
    {
      id: 1,
      src: '', // cos解析后路径
      srcCopy: '', // cos 原路径
      lat: '',
      lng: '',
    },
  ], // 拍照列表
  datayime: true,
  textareaValueRemake: '',
  userSelectedLngLat: {
    lng: '',
    lat: '',
  },
  pointLngLat: {
    lng: '',
    lat: '',
  },
  userSelectedAdcode: '', // 行政区划代码
  userSelectPoint: false, // 用户是否戳点
})
// 预览图片列表
const previewObj = reactive({
  imageList: [],
  initPage: 0,
  showPreviewImg: false,
});

const isShowPicAndLoc = ref(false); // 在截图时是否需要隐藏DOM
const showBasic = ref(false); // 是否展示上传中
const userCheckDetail = ref(false); // 是否是查看
const laneTypeVisible = ref(false); // 车道选择弹窗是否展示
const datePickerVisible = ref(false); // 日期选择弹窗是否展示
const isAllowExit = ref(false); // 是否允许退出页面
const userFillInComplete = ref(false); // 用户是否填写完整信息
const dateTimeStart = ref(new Date().toLocaleString());
const datePicker = ref(new Date().toLocaleString());
const currentTimeType = ref(''); // 当前选择的时间类型
const checkCosUrl = ref(''); // 查看时cos链接
const domToImageSrc = ref(''); // 截图后canvas转图片

const columns = ref([
  { label: '第一车道', value: '第一车道', key: 1001 },
  { label: '第二车道', value: '第二车道', key: 1002 },
  { label: '第三车道', value: '第三车道', key: 1003 },
  { label: '第四车道', value: '第四车道', key: 1004 },
]);
const reportTypeBtnList = reactive([
  { id: 1, name: '事故', active: false, key: 30 },
  { id: 2, name: '施工', active: false, key: 20 },
  { id: 3, name: '封路', active: false, key: 10 },
  { id: 4, name: '交通管制', active: false, key: 50 },
  { id: 5, name: '道路积水', active: false, key: 100 },
  { id: 6, name: '道路结冰', active: false, key: 63 },
  { id: 7, name: '大雾', active: false, key: 62 },
  { id: 8, name: '车辆故障', active: false, key: 140 },
  { id: 9, name: '', },
]);
const laneTypeList = reactive([
  { id: 1, name: '主路', active: false, },
  { id: 2, name: '应急车道', active: false, key: 5 },
  { id: 3, name: '左侧车道', active: false, key: 2 },
  { id: 4, name: '中间车道', active: false, key: 3 },
  { id: 5, name: '右侧车道', active: false, key: 4 },
  { id: 6, name: '', },
]);
const laneDirectionList = reactive([
  { id: 1, name: '由东向西', active: false, },
  { id: 2, name: '由西向东', active: false, },
  { id: 3, name: '由南向北', active: false, },
  { id: 4, name: '由北向南', active: false, },
  { id: 5, name: '其他', active: false, },
  { id: 6, name: '', },
])
// const isControlList = reactive([
//   { id: 1, name: '是', active: false, key: 1 },
//   { id: 2, name: '否', active: false, key: 0 },
//   { id: 3, name: '', },
// ])

const cosByScene = new Cos({
  getAuthorization: function(options, callback) {
    request("post", getCosCredentialsByScene, {
      scene: 'info_report',
      ext_info: {
        openid: store.state.userOpenId
      }
    })
    .then(data => {
      callback({
        TmpSecretId: data.data.credentials.tmp_secret_id,
        TmpSecretKey: data.data.credentials.tmp_secret_key,
        SecurityToken: data.data.credentials.session_token,
        ExpiredTime: data.data.credentials.expired_time
      });
    });
  }
})

const clearWayName = () => {
  messageObj.wayName = '';
}
const showSelectLanePopup = () => {
  laneTypeVisible.value = true;
}
const laneTypePickerConfirm = (value) => {
  laneTypeVisible.value = false;
  messageObj.laneTypePickerVal = value;
}
const reportTypeBtnClick = (id) => {
  if (id === 9) return
  setOptinosValue(reportTypeBtnList, 'reportType', '', false, id)
}
const laneTypeBtnClick = (id) => {
  if (id === 6) return;
  laneTypeList.forEach(item => {
    if (item.id === id) {
      item.active = !item.active;
    }
  });
  messageObj.laneType = laneTypeList.filter(item => item.active).map(item => item.id);
}
const laneDirectionBtnClick = (id) => {
  if (id === 6) return;
  setOptinosValue(laneDirectionList, 'laneDirection', 'textareaValueLaneDirection', id === 5, id)
}
// const isControlBtnClick = (id) => {
//   if (id === 3) return;
//   setOptinosValue(isControlList, 'isControl', '', false, id);
// }
const setOptinosValue = (options, prop, textName, idControl, id) => {
  options.forEach(item => {
    item.active = false;
  })
  options.find(item => item.id === id).active = true;
  messageObj[prop] = id;
  if(idControl) {
    messageObj[textName] = '';
  }
}
// ===================== 提取腾讯地图 Canvas 转图片=====================
const getMapScreenshot = async () => {
  return new Promise((resolve, reject) => {
    try {
      // 找到腾讯地图的 Canvas 元素
      const mapDom = document.getElementsByTagName('canvas')[0];
      const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); //ios终端
      if (ios) {
        domtoimage
          .toPng(mapDom)
          .then(() => {
            return domtoimage
              .toPng(mapDom);
          })
          .then((dataUrl) => {
            resolve(dataUrl);
          })
          .catch((error) => {
            console.error('图片生成失败', error);
          })
      } else {
        domtoimage
          .toPng(mapDom)
          .then(function (dataUrl) {
            resolve(dataUrl);
          })
          .catch(function (error) {
            console.error('domtoimage 出现问题! ', error);
          });
      }
    } catch (err) {
      reject(`地图截图失败：${err.message}`);
    }
  });
};
const createMapImage = async () => {
  const mapBase64 = await getMapScreenshot();
  if (!mapBase64) {
    Toast.text('截图失败，请重试');
    return;
  }
  domToImageSrc.value = mapBase64;
}
const addWatermark = () => {
  if (!screenshotContainer.value || !config.watermark) return;
  const container = screenshotContainer.value;

  // 移除旧水印
  document.querySelectorAll(".watermark-text").forEach(wm => wm.remove());
  container.style.position = "relative"; // 确保水印绝对定位

  const { fontSize, color, rotate, spacing, zIndex } = config.watermark;
  const { scrollWidth: width, scrollHeight: height } = container;
  const cols = Math.ceil(width / spacing);
  const rows = Math.ceil(height / spacing);

  // 循环生成水印
  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
      const wm = document.createElement("div");
      wm.className = "watermark-text";
      wm.style.cssText = `
        position: absolute;
        top: ${i * spacing}px;
        left: ${j * spacing}px;
        font-size: ${fontSize};
        color: ${color};
        transform: rotate(${rotate}deg);
        pointer-events: none; /* 不拦截交互 */
        z-index: ${zIndex};
        white-space: nowrap;
      `;
      wm.textContent = '企鹅汇图';
      container.appendChild(wm);
    }
  }
};

/** 移除所有水印 */
const removeWatermark = () => {
  document.querySelectorAll(".watermark-text").forEach(wm => wm.remove());
  if (screenshotContainer.value) {
    screenshotContainer.value.style.position = "";
  }
};

// ===================== 生成截图（html2canvas）=====================
const generateScreenshot = async (type, toast = null) => {
  try {
    screenshotBase64.value = '';
    randomKey.value = Math.random().toString(36).slice(2, 8);
    const container = screenshotContainer.value;
    // 添加水印（无需水印可注释）
    addWatermark();
    await nextTick();

    // 调用 html2canvas 生成截图
    const canvas = await html2canvas(container, {
      ...config.html2canvas,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
    });
    // 移除水印
    removeWatermark();
    const blob = await new Promise((resolve) => {
      // 格式选 jpeg（比 png 小 50%+），质量 0.8（0-1 可调，平衡质量和大小）
      canvas.toBlob(resolve, "image/jpeg", 0.8);
    });
    const reader = new FileReader();
    reader.onloadend = () => {
      console.log(reader.result, 'result')
      removeWatermark();
      screenshotBase64.value = reader.result; // 压缩后的 base64
      sendToMiniProgram(type, toast)
    };
    reader.readAsDataURL(blob);
  } catch (err) {
    showBasic.value = false;
    isShowPicAndLoc.value = false;
    removeWatermark();
    console.error("html2canvas 截图失败：", err);
  }
};

// ===================== 向小程序发送截图数据 =====================
const sendToMiniProgram = (type, toast) => {
  isShowPicAndLoc.value = false;
  showBasic.value = false;
  // 将 base64 传给小程序（encodeURIComponent 避免特殊字符截断）
  wx.miniProgram.postMessage({
    data: {
      type: "screenshot",
      base64: encodeURIComponent(screenshotBase64.value),
      title: "企鹅汇图截图保存",
      event: type, // 1 提交 2 查看
    },
  });
  if (type === 2) {
    setTimeout(() => {
      toast.hide();
      wx.miniProgram.redirectTo({
        url: `/pages/h5WebSuccess/h5WebSuccess?isShare=true`
      })
    }, 5000);
  }
};

const showTimePicker = (type) => {
  datePickerVisible.value = true;
  currentTimeType.value = type;
}
const datePickerConfirm = (value) => {
  if (currentTimeType.value === 'start') {
    messageObj.info.startTime = value;
  } else if (currentTimeType.value === 'end') {
    if(new Date(value) - new Date(messageObj.info.startTime) < 300000) {
      Notify.warn('时间间隔不得小于5分钟');
      return;
    }
    messageObj.info.endTime = value;
  }
  datePickerVisible.value = false;
}
const previewImageHandel = (index) => {
  previewObj.imageList = JSON.parse(JSON.stringify(messageObj.locationPics));
  previewObj.initPage = index;
  previewObj.showPreviewImg = true;
};
const changeBasic = () => {
  showBasic.value = false;
  isShowPicAndLoc.value = false;
}
const getShowPreviewImg = val => {
  previewObj.showPreviewImg = val;
};
// 文件删除
const uploadDelete = index => {
  messageObj.locationPics.splice(index, 1);
};
const locationPicsFileChange = () => {
  if (messageObj.locationPics.length > 3) {
    Notify.warn('最多上传3张图片');
    return;
  }
  showBasic.value = true;
  const a = document.getElementById('file');
  console.log(a.files, 'ssssssssssssssssssss');
  let type = 'jpg';
  setMiniImg(a.files[0]).then(miniImgFile => {
    if (miniImgFile) {
      if (miniImgFile.type && miniImgFile.type.indexOf('png') > -1) {
        type = 'png';
      }
      CosPutObjectwx(miniImgFile, type)
    } else {
      CosPutObjectwx(a.files[0], type)
    }
  }).catch(() => {
    showBasic.value = false;
  })
}
// 推送文件到COS wexin
const CosPutObjectwx = async (fileItem, type) => {
  let a = store.state.userOpenId || 'oA9LiwK_7Hi3VC-BVHBc6WRQFbew';
  console.log(a,'a');
  console.log(fileItem);
  const key = `easyearn/info_report/${a}/road/evaluating/${a}/${new Date().getTime()}.${type}`;
  cosByScene.putObject(
    {
      Bucket: 'mapugc-user-1251316161',
      Region: 'ap-beijing',
      Key: key,
      StorageClass: "STANDARD",
      Body: fileItem,
      onProgress: function() {}
    },
    function(err, datas) {
      console.log(err,'err');
      console.log(datas,'data');
      if (!datas) {
        Notify.warn("上传失败");
        showBasic.value = false;
        return;
      }
      if (datas.Location) {
        messageObj.locationPics.push({
          id: messageObj.locationPics.length,
          src: '',
          srcCopy: '',
          lat: '',
          lng: '',
        })
        const { lat, lng } = messageObj.pointLngLat;
        messageObj.locationPics[messageObj.locationPics.length - 1].lat =  messageObj.userSelectedLngLat.lat || lat;
        messageObj.locationPics[messageObj.locationPics.length - 1].lng = messageObj.userSelectedLngLat.lng || lng;
        messageObj.locationPics[messageObj.locationPics.length - 1].srcCopy = `https://${datas.Location}`;
        recivePicPathGetUrlwxin([datas.Location], messageObj.locationPics.length - 1);
      }
    }
  );
};
const recivePicPathGetUrlwxin = (res, pIndex) => {
  res.forEach((item, index) => {
    const picIndex = pIndex || index;
    const cosurl = item.includes('http') ? item : `https://${item}`
    window.getReadOnlyPresignedUrlApi(cosurl).then(url => {
      messageObj.locationPics[picIndex].src = url;
      showBasic.value = false;
    }).catch(err => {
      console.log(err, 'err');
      showBasic.value = false;
    });
  });
};
const PicLoction = () => {
  if (store.state.isH5) {
    if(messageObj.datayime) {
      goweixin();
      messageObj.datayime = false;
      setTimeout(() => { messageObj.datayime = true }, 3000)
    }
  } else {
    if (window.easyearn) {
      window.easyearn.picLocation(
        messageObj.userSelectedLngLat.lng,
        messageObj.userSelectedLngLat.lat,
        userCheckDetail.value,
        false,
        "200",
        true,
      );
    }
  }
}
const goweixin = () => {
  let fullPath = route.fullPath;
  localStorage.setItem('police_report_data', JSON.stringify(messageObj))
  wx.miniProgram.navigateTo({url: `/pages/H5PicLocation/H5PicLocation?userCheckDetail=${userCheckDetail.value}&latitude=${
    messageObj.userSelectedLngLat.lat}&longitude=${messageObj.userSelectedLngLat.lng}&reportType=${messageObj.reportType}&from=h5HuiTu&url=${fullPath}`})
}
// 存储桶获取信息--页面查看时
const checkDetailReqCos = () => {
  const key = checkCosUrl.value.includes('http') ? checkCosUrl.value : 'https://' + checkCosUrl.value;
  window.getReadOnlyPresignedUrlApi(key).then(url => {
    getCosJSON(url)
  }).catch(err => console.log(err, 'err'));
};
// 获取cos存储的json
const getCosJSON = url => {
  request("get", url).then(res => {
    console.log(res, 'cosUrssssssssssssssl');
    // 给页面赋值
    messageObj.wayName = res.locationName;
    messageObj.userSelectedLngLat = {
      lat: res.eventLocation.split(',')[0],
      lng: res.eventLocation.split(',')[1],
    }
    InitMap();
    messageObj.pointLngLat = messageObj.userSelectedLngLat;
    const reportType = reportTypeBtnList.find(item => item.key === res.eventType);
    const laneType = res.laneType.split(',').map((item) => {
      if (item.includes('100')) {
        const lane = columns.value.find(column => column.key === item - 0).label;
        return `主路-${lane}`
      } else {
        return laneTypeList.find(listItem => listItem.key === item - 0).name
      }
    })
    messageObj.reportTypeLabel = reportType.name;
    messageObj.laneTypeLabel = laneType.join('，');
    messageObj.laneDirectionLabel = res.direction;
    // messageObj.isControlLabel = res.isControlled === 1 ? '是' : '否';
    messageObj.info = {
      startTime: res.eventStartTime,
      endTime: res.eventEndTime,
    }
    const imgList = [];
    res.locationPics.map((item, index) => {
      if(item.url) {
        const picObj = {
          id: index + 1,
          src: '',
          srcCopy: item.url,
          lat: messageObj.userSelectedLngLat.lat,
          lng: messageObj.userSelectedLngLat.lng,
        }
        imgList.push(picObj)
      }
    });
    messageObj.locationPics = imgList;
    messageObj.textareaValueRemake = res.notes;
    checkUrlGet();
  }).catch((err) => {
    console.log(err, 'getCosJSON-err')
    Notify.warn('上报信息获取失败，请重试');
  });
};
// 给图片赋值
const checkUrlGet = () => {
  const urlArr = messageObj.locationPics.map(item => item.srcCopy);
  recivePicPathGetUrlwxin(urlArr);
};
// 检验表单
const validator = () => {
  const {
    reportType,
    // isControl,
    laneType, laneTypePickerVal, wayName,
  } = messageObj;
  // 校验事件结束时间不能小于当前时间5分钟之内
  const nowTime = new Date();
  nowTime.setSeconds(0);
  nowTime.setMilliseconds(0);
  const endTime = new Date(messageObj.info.endTime);
  endTime.setSeconds(0);
  endTime.setMilliseconds(0);
  const startTime = new Date(messageObj.info.startTime);
  startTime.setSeconds(0);
  startTime.setMilliseconds(0);
  if (wayName === "") {
    Notify.warn("请填写事件地点道路名称");
    return false;
  } else if (reportType === "") {
    Notify.warn("请填写道路通行状态");
    return false;
  } else if (judgeOtherText()) {
    Notify.warn("请填写车道方向其他方向内容");
    return false;
  } else if (laneType.includes(1) && laneTypePickerVal.length === 0) {
    Notify.warn("请选择主路车道");
    return false;
  } else if (!messageObj.userSelectedLngLat.lng && !messageObj.userSelectPoint) {
    Notify.warn("请进行地图打点");
    return false;
  } else if (endTime.getTime() < startTime.getTime()) {
    Notify.warn('事件结束时间不得早于事件开始时间');
    return false;
  } else if(endTime.getTime() - startTime.getTime() < 300000) {
    Notify.warn('时间间隔不得小于5分钟');
    return false;
  } else if(endTime.getTime() - nowTime.getTime() < 300000) {
    Notify.warn("事件结束时间不得早于当前上报时间+5分钟");
    return false;
  } else {
    return true;
  }
  // else if (isControl === '') {
  //   Notify.warn("请选择是否管控");
  //   return false;
  // }
};
const judgeOtherText = () => {
  const {
    laneDirection, textareaValueLaneDirection,
  } = messageObj;
  if (laneDirection === 5 && textareaValueLaneDirection === "") {
    return true;
  }
  return false;
}
// 完成上报
const FillInEvent = async () => {
  const uid = new Date().getTime();
  if (!validator()) return;
  if(userFillInComplete.value == false) return
  if (userCheckDetail.value) {
    router.go(-1)
  } else {
    await createMapImage();
    showBasic.value = true;
    isShowPicAndLoc.value = true;
    // 保存所有填写的上报信息
    let a = store.state.userOpenId || 'oA9LiwK_7Hi3VC-BVHBc6WRQFbew';
    const key = `easyearn/info_report/${a}/road/evaluating/${a}/${new Date().getTime()}/${
      uid
    }.json`;
    const { lng, lat } = messageObj.userSelectedLngLat;
    const reportTypeLablel = reportTypeBtnList.find(item => item.id === messageObj.reportType);
    const subType = reportTypeLablel.key - 0;
    const laneType = messageObj.laneType.map(item => {
      if (item === 1) return columns.value.find(column => column.label === messageObj.laneTypePickerVal[0]).key;
      else return laneTypeList.find(listItem => listItem.id === item).key;
    });
    const laneDirection = messageObj.laneDirection === '' ? '' : messageObj.laneDirection === 5 ? messageObj.textareaValueLaneDirection
      : laneDirectionList.find(item => item.id === messageObj.laneDirection).name;
    const locationPics = [];
    messageObj.locationPics.forEach(pic => {
      if (pic.srcCopy !== '') {
        const picObj = {
          url: pic.srcCopy,
          lat,
          lng,
          angle: '',
          time: messageObj.info.endTime,
          tracks: '',
        };
        locationPics.push(picObj);
      }
    })
    const extras = {
      locationName: messageObj.wayName,
      eventLocation: `${messageObj.userSelectedLngLat.lat},${messageObj.userSelectedLngLat.lng}`,
      eventType: subType,
      eventTypeComment: '', // 需求删除
      laneType: laneType.join(','),
      lane: '', // 需求删除
      direction: laneDirection,
      eventStartTime: messageObj.info.startTime,
      eventEndTime: messageObj.info.endTime,
      reporter: "",
      reporterContact: "",
      locationPics,
      notes: messageObj.textareaValueRemake,
    };
    cosByScene.putObject(
      {
        Bucket: 'mapugc-user-1251316161' /* 必须 */,
        Region: 'ap-beijing' /* 存储桶所在地域，例如ap-beijing，必须字段 */,
        Key: key /* 必须 */,
        StorageClass: "STANDARD",
        Body: JSON.stringify(extras), // 上传文件对象
        onProgress: function() {}
      },
      async function(err, datas) {
        console.log(err,'err');
        console.log(datas,'data');
        if (!datas) {
          Notify.warn("上传失败, 请重试");
          showBasic.value = false;
          isShowPicAndLoc.value = false;
          return;
        }
        await nextTick();
        await generateScreenshot(1);
        finallyAppear(datas.Location);
      }
    );
  }
}
const finallyAppear = (cosUrl) => {
  const laneType = messageObj.laneType.map(item => {
    if (item === 1) return columns.value.find(column => column.label === messageObj.laneTypePickerVal[0]).key;
    else return laneTypeList.find(listItem => listItem.id === item).key;
  });
  const { lng, lat } = messageObj.userSelectedLngLat;
  const reportTypeLablel = reportTypeBtnList.find(item => item.id === messageObj.reportType);
  const subType = reportTypeLablel.key - 0;
  const openId = store.getters.userInfo ?
    store.getters.userInfo.split('/')[0] : '';
  const extras = {
    lane_type: laneType.join(','),
  };
  const obj = {
    common: {
      version: "3.16.0",
      module_id: "2",
      vcode: "31600000",
      loc_x: lat,
      loc_y: lng,
      openId,
      imei: '',
    },
    sourceFrom: 2, // 1 app 2 小程序
    reportType: 9,
    subType,
    reportName: messageObj.wayName,
    cosUrl: `http://${cosUrl}`,
    adcode: messageObj.userSelectedAdcode,
    extras,
    address: messageObj.locationWayName,
  };
  request("post", infoReport, obj).then(res => {
    if (res.code == 0) {
      isAllowExit.value = true
      showBasic.value = false;
      wx.miniProgram.redirectTo({
        url: `/pages/h5WebSuccess/h5WebSuccess`
      })
    } else if (res.code !== 0) {
      userFillInComplete.value = true;
      showBasic.value = false;
      isShowPicAndLoc.value = false;
      Notify.warn(res.msg);
    }
  });
}
const backEvent = () => {
  if (route.query.miniProgramShare) {
    wx.miniProgram.switchTab({
      url: '/pages/userHomePagenew/userHomePagenew',
    })
  } else {
    router.go(-1);
  }
};
const shareEvent = async () => {
  const toast = Toast.text('即将为您生成分享图片，可长按图片下载或分享好友', {
    duration: 6000,
    cover: true,
    "cover-color": 'rgba(0,0,0,0.5)',
  });
  await createMapImage();
  isShowPicAndLoc.value = true;
  await nextTick();
  generateScreenshot(2, toast);
};
const getAdcode = (location) => {
  const key = 'W5ZBZ-Q5IWU-EICVA-2TYZL-HTNKS-KUFXS'
  jsonp(`https://apis.map.qq.com/ws/geocoder/v1?key=${key}&location=${location}`, {
    callbackQuery: 'callback',
    callbackName: 'jsonpCallback',
    output: 'jsonp',
  })
    .then(res => {
      console.log(res, '返回数据');
      const {
        address_component,
      } = res.result;
      console.log(address_component);
      const {
        province,
        city,
        district,
      } = address_component;
      let adcode = '';
      citys.map(item => {
        if (province.includes(item.label) || item.label.includes(province)) {
          item.children.map(item1 => {
            if (item1.label.includes(city) || city.includes(item1.label)) {
              item1.children.map(item2 => {
                if (item2.label.includes(district) || district.includes(item2.label)) {
                  adcode = item2.value;
                }
              })
            }
          })
        }
      });
      messageObj.userSelectedAdcode = adcode;
    }).catch(err => {
      Notify.warn("请求城市代码失败", err);
    })
};
const setBtnActive = (data) => {
  const {
    reportType, laneType, laneDirection,
    // isControl,
  } = data;
  reportTypeBtnList.forEach(item => {
    if (item.id === reportType) {
      item.active = true;
    }
  });
  laneTypeList.forEach(item => {
    if (laneType.includes(item.id)) {
      item.active = true;
    }
  });
  laneDirectionList.forEach(item => {
    if (item.id === laneDirection) {
      item.active = true;
    }
  });
  // isControlList.forEach(item => {
  //   if (item.id === isControl) {
  //     item.active = true;
  //   }
  // });
};
const setWeiXinConfig = () => {
  console.log(store.state.fullpath, 'fullpath')
  if(store.state.fullpath != 'no') {
    const rt = JSON.parse(localStorage.getItem('police_report_data'))
    if(rt){
      console.log(rt)
      Object.keys(rt).forEach(key => {
        messageObj[key] = rt[key];
      })
      // 赋值按钮
      setBtnActive(rt);
      const locationPics = rt.locationPics.filter(item => item.srcCopy !== '') || [];
      if(locationPics.length > 0) {
        checkUrlGet();
      }
    }
    // 从小程序回来
    if(store.state.reportSearchWX) {
      let wxdat = JSON.parse(store.state.reportSearchWX);
      messageObj.userSelectedLngLat = {
        lng: wxdat.longitude || wxdat.lng || wxdat.location.lng,
        lat: wxdat.latitude || wxdat.lat || wxdat.location.lat,
      };
      messageObj.userSelectPoint = true;
      messageObj.locationWayName = wxdat.content;
      messageObj.wayName = wxdat.street;
      // 获取adcode
      getAdcode(`${messageObj.userSelectedLngLat.lat},${messageObj.userSelectedLngLat.lng}`);
      InitMap();
    }
    console.log(messageObj, 'messageObj2')
  }
  localStorage.removeItem('police_report_data');
  store.commit('SET_fullpath', 'no');
}
const InitMap = () => {
  const map = new TMap.Map(userCheckDetail.value ? "container2" : "container", {
    id: 'container',
    zoom: 16,
    viewMode: '2d',
    pitch: 0,
    doubleClickZoom: false,
    draggable: false,
    scrollable: false,
    touchZoomable: false,
    showControl: false,
    renderOptions: {
      preserveDrawingBuffer: true, // 保留地图的渲染缓冲 默认false
    },
    center: new TMap.LatLng(messageObj.userSelectedLngLat.lat, messageObj.userSelectedLngLat.lng),
  })
  new TMap.MultiMarker({
    id: 'marker-layer',
    map: map,
    styles: {
      "marker": new TMap.MarkerStyle({
        "width": 20,
        "height": 30,
        "src": 'https://cdn.map.qq.com/miniprogram/images/poiLocation_1104_mark.png'
      })
    },
    geometries: [{
      "id": 'demo',
      "styleId": 'marker',
      "position": new TMap.LatLng(messageObj.userSelectedLngLat.lat, messageObj.userSelectedLngLat.lng),
    }]
  });
  map.on('click', () => {
    if (messageObj.userSelectPoint) {
      PicLoction();
    }
  });
}

onBeforeMount(() => {
  if (store.state.isH5 && route.query.from != "history") {
    userCheckDetail.value = false;
  } else if (route.query.from == "index") {
    userCheckDetail.value = false;
  } else if (route.query.from == "history") {
    // 查看详情页面
    checkCosUrl.value = route.query.cosUrl;
    userCheckDetail.value = true;
    messageObj.userSelectPoint = true;
    userFillInComplete.value = true;
    messageObj.locationWayName = route.query.locationWayName;
    // 请求cos的URL
    checkDetailReqCos();
  }
  // // 独立判断交警上报并且分享给朋友后的查看
  // if (store.state.isH5 && route.query.userCheckDetail && route.query.cosUrl !== '') {
  //   checkCosUrl.value = route.query.cosUrl;
  //   userCheckDetail.value = true;
  //   messageObj.userSelectPoint = true;
  //   userFillInComplete.value = true;
  //   messageObj.locationWayName = route.query.locationWayName;
  //   checkDetailReqCos();
  // }
})
onMounted(() => {
  console.log(store.state, 'store.state')
  navigator.geolocation.getCurrentPosition((position) => {
    // position.coords 包含位置信息
    const { latitude, longitude } = position.coords;
    console.log(latitude, longitude, 'coords');
    messageObj.pointLngLat = {
      lat: latitude,
      lng: longitude,
    };
    setWeiXinConfig();
  }, err => {
    console.log(err, 'err');
    setWeiXinConfig();
  }, {
    enableHighAccuracy: true, // 是否启用高精度（true 可能更耗电，默认 false）
    maximumAge: 0 // 位置缓存时间（毫秒，0 表示不使用缓存，默认 0）
  });
})
onBeforeRouteLeave((to, from) => {
  console.log('路由离开前执行', to, from);
  if(!isAllowExit.value) {
    if (previewObj.showPreviewImg) {
      previewObj.showPreviewImg = false;
      return false;
    }
  }
  // 默认允许导航
  return true;
})
onUnmounted(() => {
  screenshotBase64.value = '';
  screenshotContainer.value = null;
})

watch(
  () => [
    messageObj.wayName,
    messageObj.reportType,
    messageObj.laneType,
    messageObj.info.startTime,
    messageObj.info.endTime,
    messageObj.userSelectPoint,
  ],
  newVal => {
    if (userCheckDetail.value) return;
    userFillInComplete.value = false;
    if (
      newVal[0] !== '' &&
      newVal[1] !== '' &&
      newVal[2].length > 0  &&
      newVal[3] !== '请选择' &&
      newVal[4] !== '请选择' &&
      newVal[5] !== false
    ) {
      userFillInComplete.value = true;
    }
  }
);

</script>
<style lang="scss" scoped>

#file {
  position: relative;
  left: 0;
  width: 100%;
  height: 100%;
  top: -80px;
  height: 100%;
  opacity: 0;
}

.fixtext {
  font-family: NotoSansCJKsc-Medium;
  font-weight: 800;
  font-size: 14px;
  color: rgba($color: #000000, $alpha: 0.7);
  line-height: 20px;
}

.goOnInfo {
  // width: 96%;
  // height: 100px;
  // margin-bottom: 150px;
  // //opacity: 0.6;
  // background: #F6F6F9;
  // border-radius: 4px;
  // outline: none;
  // border: none;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 30px !important;
  // padding: 10px 10px 0px !important;
  color: black !important;

  & :deep(nut-textarea) {
    // padding: 10px 10px 0px;
    // margin-left: -10px;
    padding: 10px 10px 0;
  }
}

#mapbox {
  width: 100vw;
  height: 100vh;
}

button,
input {
  outline: none;
}
// 修改时间位置信息
.newcss {
    font-family:Arial, Helvetica, sans-serif;

    & :deep(.t-picker__title) {
        font-size: 15px !important;
    }
    & :deep(.t-picker__cancel) {
        font-size: 15px !important;
    }
    & :deep(.t-picker__confirm) {
        font-size: 15px !important;
    }
    & :deep(.t-picker-item){
        margin-top: 20Px;
        font-family:Arial, Helvetica, sans-serif;
        font-size: 15px;
        height:  var(--td-picker-item-height, 45px);
    }
    & :deep(.t-picker__indicator) {
        top: 2rem;
        height:  var(--td-picker-item-height, 45px);;
    }
}
.newcss5 {
    font-family:Arial, Helvetica, sans-serif;

    & :deep(.t-picker__title) {
        font-size: 15px !important;
    }
    & :deep(.t-picker__cancel) {
        font-size: 15px !important;
    }
    & :deep(.t-picker__confirm) {
        font-size: 15px !important;
    }
    & :deep(.t-picker-item){
        margin-top: 6Px;
        font-family:Arial, Helvetica, sans-serif;
        font-size: 15px;
        height:  var(--td-picker-item-height, 45px);
    }
    & :deep(.t-picker__indicator) {
      top: 2rem;
      height:  var(--td-picker-item-height, 45px);;
    }
}
.t_date_time_picker_self{
  & :deep(.t-picker__indicator) {
    top: 2rem;
  }
}
.messageAppearDetail {
  background-color: #fff;
  position: relative;
  overflow: scroll;
  height: 100vh;
  padding: 0;
  .navBarBox {
    height: 66px;
  }

  .checkWayName {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }

  .navBar {
    padding: 35px 0 11px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 3;
    background-color: #fff;
    box-shadow: 0 2px 14px 0 rgba(0, 136, 255, 0.06);

    .navBarImg {
      position: absolute;
      width: 20px;
      height: 20px;
      left: 20px;
      line-height: 20px;
    }

    .navBarTitle {
      font-size: 16px;
      line-height: 20px;
      font-weight: Bold;
      text-align: center;
    }
  }

  .locationGet {
    font-size: 14px;
    height: 52px;
    line-height: 52px;
  }

  .locationGetHui {
    color: #c8c9cc;
  }

  .checkWayState {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  .auditNoPass {
    margin-right: 0;
    height: 44px;
    background: rgb(255, 68, 51, 0.08);
    display: flex;
    align-items: center;

    img {
      width: 16px;
      height: 16px;
      margin-left: 20px;
    }

    div {
      display: inline-block;
      margin-left: 5px;
      font-family: NotoSansCJKsc-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #ff4433;
    }
  }

  .mainInfo {
    background-color: #fff;
    padding-bottom: 100px;

    & .header {
      opacity: 0.9;
      // font-family: NotoSansCJKsc-Bold;
      font-family: Arial, Helvetica, sans-serif;
      font-weight: Bold;
      font-size: 16px;
      color: #000000;
      line-height: 22px;
      margin-bottom: 12px;
      margin-top: 24px;

      & i {
        &::before {
          display: inline-block;
          width: 4px;
          height: 4px;
          color: #ff4433;
          position: absolute;
          right: -4px;
          top: 0px;
          content: '*';
        }
      }

      & span {
        display: inline-block;
        position: relative;
      }
    }

    & .mg4 {
      margin-bottom: 4px;
    }

    & .wayInfo {
      width: 90%;
      margin: 0 auto;
      padding-top: 6px;

      & .way_name_nut_icon {
        position: absolute;
        right: 0;
        bottom: 12px;
        width: 28px;
        height: 28px;
      }

      & .iconShow {
        display: inline-block;
      }

      & .iconNone {
        display: none;
      }

      & .wayInfo_input {
        border: none;
        height: 52px;
      }
      & .wayNameCheck {
        line-height: 52px !important;
      }

      & :deep(.nut-input) {
        padding-left: 0;
        padding-right: 0;
        input::-webkit-input-placeholder {
          color: #c8c9cc;
          font-size: 14px;
        }
        input::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #c8c9cc;
          font-size: 14px;
        }
        input:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #c8c9cc;
          font-size: 14px;
        }
        input:-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: #c8c9cc;
          font-size: 14px;
        }
      }



      & .wayName {
        position: relative;

        & div {
          border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
        }
      }

      & .wayPassStatus {
        .btn_box {
          display: flex;
          justify-content: space-between;
        }
        & button {
          width: 27.8vw;
          height: 38px;
          box-sizing: border-box;
          border-radius: 4px;
          font-weight: 500;
          font-size: 14px;
          text-align: center;
          line-height: 38px;
        }
        :deep(.nut-cell__link.nut-icon) {
          font-size: 13px;
        }
        .laneSelect {
          box-shadow: none;
          padding: 16px 0;
          border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
          .required {
            display: inline-block;
            width: 4px;
            height: 4px;
            color: #ff4433;
          }
        }
        .laneInput {
          color: #666;
          :deep(.nut-input-value) {
            input {
              color: #ccc;
            }
          }
        }
        .setBtnSize {
          font-size: 13px;
        }

        & .defaultBtn {
          color: #000000;
          border: 1px solid rgba($color: #17181a, $alpha: 0.15);
          background: rgba($color: #fff, $alpha: 0.15);
        }

        & .activeBtn {
          background: #e5f3ff;
          border: 1px solid #0088ff;
          color: #0088ff;
        }
        & .hideBtn {
          border: none;
          background-color: transparent;
        }
      }

      & .message_map {
        .mapBanner {
          width: 100%;
          position: relative;
          #container,
          #container2 {
            height: 150px;
          }
        }
        img {
          width: 100%;
          display: block;
        }

        p {
          font-weight: 5000;
          font-size: 12px;
          text-align: center;
          color: rgba($color: #000000, $alpha: 0.5);
          margin-top: 8px;
        }
      }

      & .message_description {
        div {
          // opacity: 0.6;
          // background: #f0f1f5;
          background-color: rgba($color: #f0f1f5, $alpha: 0.6);
          border-radius: 4px;

          & :deep(.nut-textarea) {
            background-color: transparent;
            height: 100%;
            min-height: 80px;
          }

          & :deep(.nut-textarea__textarea) {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
          }
        }
        div.remakeDiv {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          padding: 12px 30px;
        }
        .otherReason {
          font-size: 13px;
          color: rgba($color: #000000, $alpha: .7);
        }
        .message_usercheck {
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          background: #fff;
          border-radius: 0px;
          opacity: 1;
        }
      }

      & .message_uploader {
        font-family: NotoSansCJKsc-Medium;
        font-weight: 500;
        font-size: 14px;
        color: rgba($color: #000000, $alpha: 0.7);
        line-height: 20px;

        & :deep(.nut-uploader) {
          margin-top: 12px;
        }

        .lastP {
          margin-bottom: 12px;
        }

        .uploadEx {
          display: inline-block;
          width: 80px;
          height: 106px;
          vertical-align: top;
          margin-right: 10px;
          margin-bottom: 16px;

          img {
            width: 100%;
            height: 80px;
            display: block;
            border-radius: 4px;
          }

          span {
            opacity: 0.5;
            font-weight: 500;
            font-size: 12px;
            text-align: center;
            display: block;
            margin-top: 9px;
          }
        }

        .upladItem {
          display: inline-block;
          width: 80px;
          height: 106px;
          vertical-align: top;
          margin-right: 10px;
          margin-bottom: 16px;

          & :deep(.nut-cell) {
            width: 100%;
            height: 100%;
            padding: 0;
            margin: 0;
            border-radius: 4px;
            overflow: hidden;

            .iconDelete {
              width: 14px;
              height: 14px;
              background: rgba(0, 0, 0, 0.7);
              color: white;
              position: absolute;
              top: 4px;
              right: 4px;
              font-size: 6px;
              border-radius: 50%;
            }
          }

          img {
            width: 80px;
            height: 80px;
            border-radius: 4px;
          }

          .span {
            opacity: 0.5;
            font-weight: 500;
            font-size: 12px;
            text-align: center;
            display: block;
            margin-top: 9px;
          }
        }

        .uploadCss {
          width: 80px;
          height: 106px;
          display: inline-block;
          vertical-align: top;

          div {
            width: 100%;
            height: 80px;
            background: rgba(0, 136, 255, 0.1);
            border-radius: 4px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 4px;
            }
          }
          #file{
            position: relative;
            left: 0;
            width: 100%;
            top: -80px;
            height: 100%;
            opacity: 0;
          }
          span {
            opacity: 0.5;
            font-weight: 500;
            font-size: 12px;
            text-align: center;
            display: block;
            margin-top: 9px;
          }
        }
      }

      & .message_link {
        & div {
          border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
        }
      }

      & .message_remake {
        & div {
          // opacity: 0.6;
          background-color: rgba($color: #f0f1f5, $alpha: 0.6);
          // background: #f0f1f5;
          border-radius: 4px;
        }

        & :deep(.nut-textarea) {
          background-color: transparent;
          height: 100%;
        }

        & :deep(.nut-textarea__textarea) {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
        }

        .message_usercheck {
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          background: #fff;
          // background-color: rgba($color: #fff, $alpha: 1);
          border-radius: 0px;
          opacity: 1;
        }
      }
    }
  }

  .appeared {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    padding: 19px 0;
    text-align: center;
    background-color: #fff;
    box-shadow: 0 -4px 10px 0 rgba(0, 0, 0, 0.05);

    & button {
      width: 90%;
      padding: 13px 0;
      border: none;
      background-color: #e5f3ff;
      border-radius: 38px;
      font-weight: Bold;
      font-size: 16px;
      color: #fff;
      text-align: center;
      line-height: 16px;
      -webkit-tap-highlight-color: rgb(0, 0, 0, 0);
      -webkit-tap-highlight-color: transparent;
      outline: none;
    }

    .complete {
      background-color: #0088ff;
    }
    .backEvent {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      button {
        width: 70%;
      }
    }
    .hiddenBackEvent {
      button {
        width: 90%;
        margin: 0 auto;
      }
      img {
        display: none;
      }
    }
    .shareF {
      width: 32px;
      height: 32px;
      margin-left: 10px;
    }
  }

  .dialog_info {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    line-height: 21px;
  }

  .dialogObscuration {
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 4;

    .dialogImg {
      background: url("../assets/image_message_appear/messageAppearDetail.png");
      background-size: 320px 171px;
      width: 320px;
      height: 171px;
      position: fixed;
      top: 50%;
      margin-top: -85px;
      left: 50%;
      margin-left: -160px;

      span {
        display: inline-block;
        position: absolute;
        width: 92px;
        height: 42px;
        bottom: 20px;
        border-radius: 21px;
      }

      span:nth-of-type(1) {
        right: 112px;
      }

      span:nth-of-type(2) {
        right: 20px;
      }
    }
  }

  .history_info_loading {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    background: white;
    z-index: 2;

    i {
      position: fixed;
      top: 40%;
      left: 50%;
      margin-left: -13px;
    }
  }

}
</style>
